import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
// import NavBar from "@/component/navBar"
// import ClassTypeMajor from "@/component/classTypeMajor"
// import "http://api.map.baidu.com/api?v=3.0&ak=4IU3oIAMpZhfWZsMu7xzqBBAf6vMHcoa"
// import MapContainer from "@/component/mapContainer"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

// import { Map, Marker, NavigationControl } from "react-bmap"

import $api from "@/api/index"

function CollegeDetail(props) {
  const classnames = classModuleGenerator(styles)

  const [collegeInfo, setCollege] = useState({})
  // const [classList, setClassList] = useState([])
  const { id } = useParams()

  useEffect(() => {
    // const getClassList = async () => {
    //   const { result } = await $api.college.relation(id)
    //   setClassList(result || [])
    // }

    const getCollegeInfo = async () => {
      const { result } = await $api.college.info(id)
      if (result?.[0].mapPoint) {
        result[0].lng = result?.[0].mapPoint.split(",")[0]
        result[0].lat = result?.[0].mapPoint.split(",")[1]
      }
      setCollege(result?.[0] || [])
    }

    getCollegeInfo()
  }, [])

  return (
    <>
      <div className={classnames("collegeDesc-container")}>
        <h3 className="section__title">学校简介</h3>
        <div className={classnames("college-desc", "clearfix")}>
          <img
            className={styles.collegeConver}
            src={collegeInfo.coverUrl}
            alt=""
          />
          <div>
            <p className={classnames("desc-style")}>{collegeInfo.intro}</p>
            <ul className="clearfix">
              <li>
                <h5>占地面积</h5>
                <p>{collegeInfo.floorArea}</p>
              </li>
              <li>
                <h5>专业数量</h5>
                <p>{collegeInfo.professions}</p>
              </li>
              <li>
                <h5>在校人数</h5>
                <p>{collegeInfo.schoolPerson}</p>
              </li>
            </ul>
            {collegeInfo.code && (
              <p className={classnames("code-style")}>
                招生代码：{collegeInfo.code}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className={classnames("collegeType-container")}>
        <h3 className="section__title">升学班型</h3>
        <div className={classnames("class-type", "clearfix")}>
          <div className={classnames("classtype-left")}>
            <h5>普通高考升学班</h5>
            <button
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              了解更多+
            </button>
          </div>
          <div className={classnames("classtype-right")}>
            <p className={classnames("classtype-desc")}>
              三年全日制教学学习管理模式，学大依托职业学校现有专业或新申请专业，面向应届初中毕业生设置普通高考或职普融通升学班。
            </p>
            <h5>计算机专业普通高考升学班</h5>
            <div className={classnames("classtype-footer")}>
              <p className={classnames("plan")}>招生计划：300人 </p>
              <button
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                领取招生简章
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={classnames("collegeInfo-container")}>
        <h3 className="section__title">校区信息</h3>
        <div className={classnames("college-info", "clearfix")}>
          <div className={classnames("collegeinfo-left")}>
            <p>联系方式：{collegeInfo.phone}</p>
            <p>校区地址：</p>
            <p className={classnames("college-address")}>
              {collegeInfo.address}
            </p>
            <div className={classnames("map-wrap")} style={{visibility:'hidden'}}>
              {/* {collegeInfo.mapPoint && (
                <Map
                  center={{ lng: collegeInfo.lng, lat: collegeInfo.lat }}
                  zoom="11"
                  style={{ height: "100%" }}
                >
                  <Marker
                    icon="loc_blue"
                    position={{ lng: collegeInfo.lng, lat: collegeInfo.lat }}
                  />
                  <NavigationControl />

                  <Marker
                    position={{ lng: collegeInfo.lng, lat: collegeInfo.lat }}
                    offset={{ width: 0, height: -80 }}
                  >
                    <div
                      style={{
                        background: "rgba(0,0,0,0.3)",
                        padding: "10px",
                        borderRadius: "5px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        color: "#fff",
                        transform: "translate(-50%)",
                      }}
                    >
                      {collegeInfo.name}
                    </div>
                  </Marker>
                </Map>

                // <MapContainer
                //   mapPoint={collegeInfo.mapPoint}
                //   name={collegeInfo.name}
                // />
              )} */}
            </div>
          </div>
          <div className={classnames("collegeinfo-right")}>
            {collegeInfo.photos && (
              <>
                <p>校区风采：</p>
                <ul className="clearfix">
                  {(collegeInfo.photos || []).map((src) => {
                    return (
                      <li key={src}>
                        <img src={src} alt="" />
                      </li>
                    )
                  })}
                </ul>
              </>
            )}
            {/* <p>校区风采：</p> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default CollegeDetail
